import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import {
  AbstractControl,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { Category } from '../../../models/category.model';
import { ApiV2Service } from '../../../services/api-v2.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LessonCard } from '../../../interfaces/lesson-card.interface';
import { SpinnerService } from '../../../services/spinner.service';
import { CourseCard } from '../../../interfaces/course-card.interface';
import { Organization } from '../../../interfaces/organization-info.interface';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { AuthService } from '../../../services/auth.service';
import { MessagesModalService } from '../../../services/messages-modal.service';
import { categorylessons } from 'src/app/mocks/category-lessons.mock';
import { isTemplateExpression } from 'typescript';
import { TranslateService } from '@ngx-translate/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
@Component({
  selector: 'app-dialog-grade-creator',
  templateUrl: './dialog-grade-creator.component.html',
  styleUrls: ['./dialog-grade-creator.component.css'],
})
export class DialogGradeCreatorComponent implements OnInit {
  createLessonForm: FormGroup;

  categories: Category[] = JSON.parse(localStorage.getItem('categories'));
  filteredCategories: Observable<Category[]>;
  filteredCategories2: any[] = [];
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  courseId: number;
  lessonId: number;
  actualLesson: any;
  action: string = 'CREATE_LESSON';

  courses: CourseCard[] = [];
  allCourses: CourseCard[] = [];
  filteredCourses: Observable<CourseCard[]>;
  filteredCourses2: any[] = [];
  removedCourses: CourseCard[] = [];
  cretaedLesson: boolean = false;
  LessonCreate: any;

  @ViewChild('courseInput') courseInput: ElementRef<HTMLInputElement>;
  activityCardInfo: any;
  @ViewChild('select') private select: MatSelect;
  constructor(
    private translate: TranslateService,
    private api: ApiV2Service,
    private spinner: SpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private ref: ChangeDetectorRef,
    private auth: AuthService,
    private dialogRef: MatDialogRef<DialogGradeCreatorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private message: MessagesModalService
  ) {
    this.createLessonForm = new FormGroup({
      name: new FormControl(null, Validators.required),
      category: new FormControl(null),
      // age: new FormControl(null),
      resources: new FormControl(null),
      courses: new FormControl(null),
    });
  }

  public closeMe() {
    this.dialogRef.close();
  }
  public closeMe2(string: string) {
    this.dialogRef.close(string);
  }

  ngOnInit(): void {
    this.createLessonForm.valueChanges.subscribe(() => {
      this.ref.markForCheck();
    });
    const organizations: Organization = this.auth.currentMainOrganization;
    this.getCoursesByOrganization({
      organization: organizations.id,
      limit: 1000000,
    });
    /* const organizations: Organization[] = JSON.parse(localStorage.getItem('user'))['organizations'];
    for (let org of organizations) {
      if (org.organizationType === 'Familia') {
        this.getCoursesByOrganization({ organization: org.id });
      }
    } */
    this.createLessonForm.get('courses').valueChanges.subscribe(() => {
      this.select.close();
    });
  }

  getCoursesByOrganization(params?: any) {
    this.spinner.showSpinner = true;
    this.api
      .getService('GET_COURSES_BY_ORGANIZATION', params)
      .pipe(
        map((data) => {
          return data['results'];
        })
      )
      .subscribe(
        (courses: CourseCard[] | any[]) => {
          this.allCourses = [...this.allCourses, ...courses];
          this.filteredCourses = this.createLessonForm
            .get('courses')
            .valueChanges.pipe(
              startWith(''),
              map((value) => this._filter(value, this.allCourses))
            );
          this.filteredCourses2 = this.allCourses.map((item) => item);
          // console.log('filteredCourses', this.filteredCourses2);
          // console.log(this.allCourses);
          this.getCategories();
        },
        (error) => {
          console.log('Error:', error);
          this.spinner.showSpinner = false;
        }
      );
  }

  getCategories() {
    this.spinner.showSpinner = true;
    this.api
      .getService('GET_CATEGORIES')
      .pipe(
        map((data) => {
          return data['results'];
        })
      )
      .subscribe((categories: Category[]) => {
        categories = categories.sort((a, b) => a.id - b.id);
        this.categories = this.categories.filter((item) => {
          for (let lessoncat of categorylessons) {
            if (lessoncat.id === item.id) return item;
          }
        });
        this.filteredCategories2 = this.categories;
        this.filteredCategories = this.createLessonForm
          .get('category')
          .valueChanges.pipe(
            startWith(''),
            map((value) => this._filter(value, this.categories))
          );
        this.route.params.subscribe((params) => {
          this.lessonId = params.lessonId;
          // console.log('Check Parametros: ', this.lessonId);
          if (this.lessonId) {
            this.getActualLessonCard();
          } else {
            this.spinner.showSpinner = false;
          }
        });
      });
  }

  /* private _filter(value: any, options: any[]): any[] {
    const filterValue = value && value.name ? value.name.toLowerCase() : value.toLowerCase();
    return options.filter(option => option.name.toLowerCase().includes(filterValue));
  } */

  private _filter(value: any, options: any[]): any[] {
    const filterValue = value && value.name ? value.name.toLowerCase() : value;
    return options.filter((option) =>
      option.name.toLowerCase().includes(filterValue) ? option.name : ''
    );
  }

  displayCategory(category: Category) {
    return category && category.name ? category.name : '';
  }

  customValidator(control: AbstractControl): { [key: string]: string } | null {
    if (typeof control.value !== 'object' && control.value !== '') {
      return { controlType: 'El tipo de dato no es válido' };
    }
    return null;
  }
  createLesson() {
    if (this.cretaedLesson) {
      // console.log(this.LessonCreate);
      this.dialogRef.close(this.LessonCreate);
      // this.message.openActivityGradeDialog('info',
      // this.translate.instant('DIALOGMESSAGEACTIVITY.CARD.ADDTOGRADEMSG0'),
      // this.data.messageActivityId)
    }
  }

  createLesson2() {
    if (this.createLessonForm.invalid) {
      this.message.openDialog(
        'danger',
        this.translate.instant('DIALOGMESSAGEERROR.TITLE'),
        this.translate.instant('DIALOGMESSAGELESSON.FORMINVALID')
      );
    } else {
      this.spinner.showSpinner = true;
      const body = {
        name: this.createLessonForm.get('name').value,
        profile_groups: this.courses.map((item: CourseCard) => item.id),
        category: this.createLessonForm.get('category').value
          ? this.createLessonForm.get('category').value.name
          : null,
        description: this.createLessonForm.get('resources').value,
      };

      this.message
        .openDialog(
          'warning',
          `${
            this.lessonId
              ? this.translate.instant('DIALOGMESSAGELESSON.EDIT')
              : this.translate.instant('DIALOGMESSAGELESSON.CREATE')
          } ${this.translate.instant('LESSONS.LESSON')}`,
          `${this.translate.instant('DIALOGMESSAGELESSON.LESSON1')} ${
            this.lessonId
              ? this.translate.instant('DIALOGMESSAGELESSON.EDITING')
              : this.translate.instant('DIALOGMESSAGELESSON.CREATING')
          } ${this.translate.instant('DIALOGMESSAGELESSON.LESSON2')}`
        )
        .afterClosed()
        .subscribe((result: boolean) => {
          if (result) {
            this.api.postService('CREATE_LESSON', body).subscribe(
              (data) => {
                if (this.courses.length > 0) {
                  this.addLessonToCourse(data['id']);
                } else {
                  if (this.removedCourses.length > 0) {
                    this.removeLessonToCourse(data['id']);
                  } else {
                    this.spinner.showSpinner = false;
                    this.message.openDialog('success',this.translate.instant('DIALOGMESSAGELESSON.CREATEOK')+' '+data['name']).afterClosed().subscribe((result) => {
                      this.LessonCreate = data;
                    this.cretaedLesson = true;
                    this.createLesson();
                    });
                    
                  }
                }
              },
              (error) => {
                console.log('Error: ', error);
                this.spinner.showSpinner = false;
                if (error.status >= 400 && error.status < 500) {
                  this.message.openDialog(
                    'danger',
                    'Error',
                    `ERROR ${error.status}: ${error.error.errors[0].msg}`
                  );
                } else if (error.status >= 500 && error.status < 600) {
                  this.message.openDialog(
                    'danger',
                    'Ups... ',
                    `ERROR ${error.status}: ${this.translate.instant(
                      'DIALOGMESSAGEERROR.LOGIN.ERROR2'
                    )}`
                  );
                }
              }
            );
          } else {
            this.spinner.showSpinner = false;
          }
        });
    }
  }

  getActualLessonCard() {
    this.spinner.showSpinner = true;
    this.api
      .getAlternativeService('GET_LESSON_BY_ID', this.lessonId)
      .pipe(
        map((data) => {
          data['courses'] = data['profile_groups']
            ? this.allCourses.filter((item) =>
                data['profile_groups'].includes(item.id)
              )
            : [];
          data['color'] = '#00AFB4';
          data['isPublic'] = data['is_public'];
          data['isInstalled'] = data['is_installed'];
          delete data['is_public'];
          delete data['is_installed'];
          return data;
        })
      )
      .subscribe(
        (lesson: LessonCard) => {
          const valueCategory: Category = this.categories.find((category) => {
            category.name === lesson.category;
          });
          this.createLessonForm.get('courses').setValue(null);
          this.courses = lesson.courses;
          // console.log(this.courses);
          this.actualLesson = {
            name: lesson.name,
            category: { name: lesson.category },
            // age: '',
            resources: lesson.description,
            courses: JSON.parse(JSON.stringify(lesson.courses)),
          };
          this.createLessonForm.setValue(this.actualLesson);
          this.createLessonForm.get('courses').setValue(this.courses);
          // console.log(lesson, this.actualLesson), valueCategory;
          // console.log(this.createLessonForm.get('courses').value);
          this.spinner.showSpinner = false;
        },
        (error) => {
          console.log('Error: ', error);
          this.spinner.showSpinner = false;
        }
      );
  }

  addCourse(course: CourseCard): void {
    // console.log(course);
    this.filteredCourses2 = this.allCourses.map((item) => item);
  }

  removeCourse2(course: CourseCard): void {
    const index = this.courses.indexOf(course);
    if (index >= 0) {
      console.log('REMOVE', course, index);
      this.courses.splice(index, 1);
    }
  }

  removeCourse(course: CourseCard): void {
    const index = this.courses.indexOf(course);
    if (index == -1) {
      const lesssons = this.createLessonForm.get('courses').value;
      this.removeFirst(lesssons, course);
      this.createLessonForm.get('courses').setValue(lesssons); // To trigger change detection
    } else {
      this.removeLessonToCourse(parseInt(course.id));
      const lesssons = this.createLessonForm.get('courses').value;
      this.removeFirst(lesssons, course);
      this.createLessonForm.get('courses').setValue(lesssons); // To trigger change detection

      // if (index >= 0) {
      //   console.log('REMOVE', course.id, index);
      //   this.courses.splice(index, 1);
      //   this.coursesId.splice(index, 1);
      //   console.log('remove',this.coursesId)
      // }
    }
  }
  private removeFirst<T>(array: T[], toRemove: T): void {
    const index = array.indexOf(toRemove);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }

  courseSelected(event: MatAutocompleteSelectedEvent): void {
    console.log('SELECTED', event, event.option.value);
    this.courses.push(event.option.value);
    this.courseInput.nativeElement.value = '';
    this.createLessonForm.get('courses').setValue('');
  }

  addLessonToCourse(lessonId: number) {
    const body = {
      grades: [lessonId],
    };
    let i = 0;
    const n = this.courses.length;
    for (let course of this.courses) {
      this.api
        .postAlternativeService('ADD_LESSONS_TO_COURSE', body, course.id)
        .subscribe(
          (data) => {
            // console.log(data);
            if (this.removedCourses.length > 0) {
              this.removeLessonToCourse(lessonId);
            } else if (
              this.courses.indexOf(course) + 1 >=
              this.courses.length
            ) {
              this.spinner.showSpinner = false;
              this.message
                .openDialog(
                  'success',
                  `${this.translate.instant('DIALOGMESSAGELESSON.NAME')} ${
                    this.lessonId
                      ? this.translate.instant('DIALOGMESSAGELESSON.EDITED')
                      : this.translate.instant('DIALOGMESSAGELESSON.CREATED')
                  }`
                )
                .afterClosed()
                .subscribe((result: boolean) => {
                  this.router.navigate(['lessons/lesson-info/', lessonId]);
                });
            }
          },
          (error) => {
            console.log('Error: ', error);
            this.spinner.showSpinner = false;
          }
        );
      //}
    }
  }

  removeLessonToCourse(lessonId: number) {
    const body = {
      grades: [lessonId],
    };
    for (let course of this.removedCourses) {
      this.api
        .postAlternativeService('REMOVE_LESSONS_TO_COURSE', body, course.id)
        .subscribe(
          (data) => {
            // this.createLessonForm.reset();
            // console.log(data);
            this.spinner.showSpinner = false;
            if (
              this.removedCourses.indexOf(course) + 1 >=
              this.removedCourses.length
            ) {
              this.message
                .openDialog(
                  'success',
                  `${this.translate.instant('DIALOGMESSAGELESSON.NAME')} ${
                    this.lessonId
                      ? this.translate.instant('DIALOGMESSAGELESSON.EDITED')
                      : this.translate.instant('DIALOGMESSAGELESSON.CREATED')
                  }`
                )
                .afterClosed()
                .subscribe((result: boolean) => {
                  this.router.navigate(['lessons/lesson-info/', lessonId]);
                });
            }
          },
          (error) => {
            console.log('Error: ', error);
            this.spinner.showSpinner = false;
          }
        );
    }
  }
}
